import { Loader2 } from 'lucide-react'

/** 全站 lazy 路由统一 loading 占位 */
export function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center gap-2 text-zinc-400">
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
      <span>加载中…</span>
    </div>
  )
}
